(function () {
  angular.module("pcmCommon")
    .constant("defaultDimensions", {
      min: {
        heightEnglish: 5, // in feet
        lengthEnglish: 8, // in feet
        weightEnglish: 1500,
        widthEnglish: 60, // in inch
        heightMetric: 1.524,
        lengthMetric: 2.4384,
        weightMetric: 680.39,
        widthMetric: 1.524,
        // eu trailer only
        trlHeightEnglish: 3, // in feet
        trlWeightEnglish: 4400,
        trlHeightMetric: 0.9144,
        trlWeightMetric: 2000
      },
      max: {
        heightEnglish: 15, // in feet
        lengthEnglish: 70, // in feet
        weightEnglish: 156470,
        widthEnglish: 102, // in inch
        heightMetric: 5,
        lengthMetric: 28,
        weightMetric: 60000,
        widthMetric: 3,
        // eu trailer only
        trlHeightEnglish: 20, // in feet
        trlWeightEnglish: 132000,
        trlHeightMetric: 6.096,
        trlWeightMetric: 60000
      },
      def: {
        truck: {
          height: 13.5,
          length: 48,
          weight: 80000,
          axles: 5,
          width: 96
        },
        light: {
          height: 13.5,
          length: 26,
          weight: 26000,
          axles: 2,
          width: 96
        },
        car: {
          height: 7,
          length: 20,
          weight: 8500,
          axles: 2,
          width: 96
        },
        euTrailer: {
          hasTrailer: false,
          trlType: 1, // None
          trlMaxHt: "13'6\"",
          trlMaxWt: 80000,
          trlCount: 0,
          trlMaxAxles: 1,
          isHybrid: false,
          minPoll: false,
          emiType: 7 // Euro V
        },
        limit: {
          elevationEnglish:7500,
          elevationMetric:2286,
          governorSpeedEnglish: 55,
          governorSpeedMetric: 88
        }
      }
    });
})();



// WEBPACK FOOTER //
// ./app/pcm-common/defaultDimensions.module.js